import { Component } from '@angular/core'
import { OrganizationService } from '@se-po/shared-data-access-services'
import { forkJoin, Observable, of } from 'rxjs'
import { catchError, map, switchMap } from 'rxjs/operators'

export const OPEN_REGISTRATION_FEATURE_TOGGLE_KEY = 'open_registration'

@Component({
  selector: 'app-registration-list-route',
  templateUrl: './registration-list-route.component.html'
})
export class RegistrationListRouteComponent {
  public showOpenRegistration$: Observable<boolean>

  constructor(private organizationService: OrganizationService) {    
    this.showOpenRegistration$ = this.organizationService.mine({ excluded_org_types: 'Team' }).pipe(
      map(response => response.result || []),
      switchMap(organizations => {
        
        if (!organizations.length) return of(false)
        
        return forkJoin(organizations.map(organization => this.organizationService.hasFeatureToggleEnabled(
          organization.id.toString(),
          OPEN_REGISTRATION_FEATURE_TOGGLE_KEY
        ).pipe(
          catchError(() => of(false))
        ))).pipe(
          map(results => results.some(Boolean))
        )
      }),
      catchError(() => of(false))
    )
  }
}
